import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./commons/Header";
import Footer from "./commons/Footer";
import Index from "./pages/Index";
import AcercaDe from "./pages/AcercaDe";
import Terminos from "./pages/Terminos";
import SidebarWithHeader from "./Layout/SidebarWithHeader";
import Pedidos from "./components/Cuenta/Pedidos";
import DetallesCuenta from "./components/Cuenta/DetallesPerfil";
import Sorteos from "./components/Sorteos";
import Registro from "./pages/Registro";
import Downloads from "./pages/Downloads"; // Nuevo componente agregado
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';



function App() {
  return (
    <Router>
      <div className="App flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow bg-white">
          <Routes>
            {/* Página principal */}
            <Route path="/" element={<Index />} />
            
            {/* Otras páginas principales */}
            <Route path="/acerca-de" element={<AcercaDe />} />
            <Route path="/terminos" element={<Terminos />} />
            <Route path="/ganadores" element={<Sorteos />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/descargas" element={<Downloads />} /> {/* Nueva ruta */}
            
<Route path="/blog" element={<Blog />} />
<Route path="/blog/:slug" element={<BlogPost />} />

            {/* Mi Cuenta - Exclusivo para cuenta de usuario */}
            <Route path="/mi-cuenta/*" element={<SidebarWithHeader />}>
              <Route path="facturacion" element={<Pedidos />} />
              <Route path="servicios" element={<Pedidos />} />
              <Route path="saldo" element={<Index />} />
              <Route path="referidos" element={<Index />} />
              <Route path="perfil" element={<DetallesCuenta />} />
            </Route>
          </Routes>
        </main>
        <Footer className="mt-0" />
      </div>
    </Router>
  );
}

export default App;
